module.exports = __webpack_public_path__ + "img/service-05.fbf9888f.png";